import { render, staticRenderFns } from "./SearchCategorySingleMobileRecipe.vue?vue&type=template&id=cee0d3c8&"
import script from "./SearchCategorySingleMobileRecipe.vue?vue&type=script&lang=js&"
export * from "./SearchCategorySingleMobileRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports